import api from './index'

const getCoinHistory = async ({ limit = 50, offset = 0 } = {}) => {
  const result = await api.get(`/api/wallet/coin/history?limit=${limit}&offset=${offset}`)

  return result
}

export default {
  getCoinHistory,
}
